export default __webpack_public_path__ + "static/media/duck.592d1f12.png";